(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("HomeBuyingSavingsCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["HomeBuyingSavingsCalculator"] = factory();
	else
		root["HomeBuyingSavingsCalculator"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition